class SortByDrawer extends HTMLElement {
  constructor() {
    super();
    this.hideDrawer = this.hideDrawer.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggleSortByDrawer = this.toggleSortByDrawer.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleSortReset = this.handleSortReset.bind(this);
  }

  get baseUrl() {
    return this.dataset.baseUrl;
  }

  get productGridSectionId() {
    const productGrid = document.querySelector("product-grid");
    if (productGrid) {
      return productGrid.dataset.sectionId;
    }
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  connectedCallback() {
    this.sortByDrawer = this.querySelector(".bosSortByDrawer");
    this.drawerOverlay = this.querySelector(".bosSortByDrawerOverlay");

    // trigger sort drawer button
    this.sortByButton = document.querySelector(".bosSortByButton");
    if (this.sortByButton) {
      this.sortByButton.addEventListener("click", this.toggleSortByDrawer);
    }

    // rebind when product grid re-renders
    document.addEventListener("product-grid:updated", () => {
      this.bindEvents();
    });

    document.addEventListener("filters-drawer:updated", () => {
      this.bindEvents();
    });

    this.bindEvents();
  }

  bindEvents() {
    // Drawer overlay
    if (this.drawerOverlay) {
      this.drawerOverlay.addEventListener("click", this.hideDrawer);
    }

    // inputs
    this.sortByInputs = this.querySelectorAll(".bosSortByDrawerInput");
    this.sortByInputs.forEach((input) => {
      input.addEventListener("change", this.handleInputChange);
    });

    // Escape key (attach once only)
    if (!this._escapeBound) {
      this._escapeHandler = (e) => {
        if (e.key === "Escape") this.hideDrawer();
      };

      document.addEventListener("keydown", this._escapeHandler);
      this._escapeBound = true;
    }

    // submit sort by form
    this.bosSortByDrawerApplyButton = this.querySelector(
      ".bosSortByDrawerApplyButton",
    );
    if (this.bosSortByDrawerApplyButton) {
      this.bosSortByDrawerApplyButton.addEventListener(
        "click",
        this.handleFormSubmit,
      );
    }

    this.bosProductGridCountSortFilter = document.querySelector(
      ".bosProductGridCountSortFilter",
    );

    if (this.bosProductGridCountSortFilter) {
      this.bosProductGridCountSortFilter.addEventListener(
        "click",
        this.handleSortReset,
      );
    }
  }

  disconnectedCallback() {
    // submit sort by form
    if (this.bosSortByDrawerApplyButton) {
      this.bosSortByDrawerApplyButton.removeEventListener(
        "click",
        this.handleFormSubmit,
      );
    }

    // stop escape listener
    if (this._escapeHandler) {
      document.removeEventListener("keydown", this._escapeHandler);
    }

    // cleanup overlay
    if (this.drawerOverlay) {
      this.drawerOverlay.removeEventListener("click", this.hideDrawer);
    }

    // cleanup inputs
    if (this.sortByInputs) {
      this.sortByInputs.forEach((input) => {
        input.removeEventListener("change", this.handleInputChange);
      });
    }

    // trigger sort drawer button
    if (this.sortByButton) {
      this.sortByButton.removeEventListener("click", this.toggleSortByDrawer);
    }

    if (this.bosProductGridCountSortFilter) {
      this.bosProductGridCountSortFilter.removeEventListener(
        "click",
        this.handleSortReset,
      );
    }
  }

  handleSortReset(e) {
    const target = e.currentTarget;
    // "?sort_by=best-selling"

    const url = new URL(window.location.href);
    // reset pagination if present
    url.searchParams.delete("page");

    // removing old
    url.searchParams.delete("sort_by");

    // add default sort
    url.searchParams.set("sort_by", "default");

    // set sections
    const sections = [this.productGridSectionId, this.sectionId].join(",");
    url.searchParams.set("sections", sections);

    // update dom
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        // product grid
        this.renderSection(
          data[this.productGridSectionId],
          this.getSectionsToUpdate(this.productGridSectionId),
        );

        // sort by drawer
        this.renderSection(
          data[this.sectionId],
          this.getSectionsToUpdate(this.sectionId),
        );

        document.dispatchEvent(new CustomEvent("sort-drawer:updated"));
        document.dispatchEvent(new CustomEvent("product-grid:updated"));

        // rebind event listeners
        this.bindEvents();

        // clear up sections param
        url.searchParams.delete("sections");

        window.history.pushState({}, "", url.toString());

        this.hideDrawer();
      })
      .catch((err) => console.error(err));
  }

  handleFormSubmit(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    // reset pagination if present
    url.searchParams.delete("page");

    // apply sort by
    this.sortByInputs?.forEach((input) => {
      // Set or update sort_by
      if (input.checked === true) {
        url.searchParams.set("sort_by", input.value);
        this.sortType = input.dataset.name;
      }
    });

    // set sections
    const sections = [this.productGridSectionId, this.sectionId].join(",");
    url.searchParams.set("sections", sections);

    // perform fetch
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        // product grid
        this.renderSection(
          data[this.productGridSectionId],
          this.getSectionsToUpdate(this.productGridSectionId),
        );

        // sort by drawer
        this.renderSection(
          data[this.sectionId],
          this.getSectionsToUpdate(this.sectionId),
        );

        // dispatch update event
        document.dispatchEvent(new CustomEvent("sort-drawer:updated"));
        document.dispatchEvent(new CustomEvent("product-grid:updated"));

        // rebind event listeners
        this.bindEvents();

        // clear up sections param
        url.searchParams.delete("sections");

        window.history.pushState({}, "", url.toString());

        this.hideDrawer();
      })
      .catch((err) => console.error(err));
  }

  handleInputChange(e) {
    this.sortByInputs?.forEach((input) => (input.checked = false));
    const target = e.currentTarget;
    target.checked = true;

    // for change on checkbox click

    // Get current URL
    const url = new URL(window.location.href);

    // reset pagination if present
    url.searchParams.delete("page");

    // Set or update sort_by
    url.searchParams.set("sort_by", target.value);

    // set sections
    const sections = [this.productGridSectionId, this.sectionId].join(",");
    url.searchParams.set("sections", sections);

    // fetch
    fetch(url.toString())
      .then((res) => res.json())
      .then((data) => {
        // product grid
        this.renderSection(
          data[this.productGridSectionId],
          this.getSectionsToUpdate(this.productGridSectionId),
        );

        // sort by drawer
        this.renderSection(
          data[this.sectionId],
          this.getSectionsToUpdate(this.sectionId),
        );

        document.dispatchEvent(new CustomEvent("sort-drawer:updated"));
        document.dispatchEvent(new CustomEvent("product-grid:updated"));

        // rebind event listeners
        this.bindEvents();

        // clear up sections param
        url.searchParams.delete("sections");

        window.history.pushState({}, "", url.toString());
      })
      .catch((err) => console.error(err));
  }

  getSectionsToUpdate(sectionId) {
    const section = document.querySelector(`[data-section-id="${sectionId}"]`);
    if (!section) return [];

    const sectionsToUpdate = section.dataset.sectionsToUpdate;
    if (!sectionsToUpdate) return [];

    return sectionsToUpdate
      .split(",")
      .map((s) => s.trim())
      .map((s) => `.${s}`);
  }

  renderSection(html, selectors) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    selectors.forEach((selector) => {
      document.querySelector(selector).innerHTML =
        temp.querySelector(selector)?.innerHTML || "";
    });
  }

  toggleSortByDrawer(e) {
    const target = e.currentTarget;
    // apply is active
    target.classList.contains("isActiveDrawer")
      ? this.hideDrawer()
      : this.showDrawer();

  }

  showDrawer() {
    this.disableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.remove("hidden");
    if (this.sortByDrawer) this.sortByDrawer.classList.add("isOpen");
    this.sortByButton?.classList.add("isActiveDrawer");
  }

  hideDrawer() {
    this.enableScrollingBody();
    if (this.drawerOverlay) this.drawerOverlay.classList.add("hidden");
    if (this.sortByDrawer) this.sortByDrawer.classList.remove("isOpen");
    this.sortByButton?.classList.remove("isActiveDrawer");
  }

  disableScrollingBody() {
    document.body.classList.add("disableScrolling");
  }

  enableScrollingBody() {
    document.body.classList.remove("disableScrolling");
  }
}

if (!customElements.get("sort-by-drawer")) {
  customElements.define("sort-by-drawer", SortByDrawer);
}
